import React, { useCallback, useState } from "react";
import { Lead } from "../../models/lead.model";
import { IUseWhatsappFormParams, useWhatsappForm } from "../../hooks/use-whatsapp-form.hook";
import styles from './whatsApp-form.module.scss';

export interface IWhatsappFormProps {
  whatsappParams: IUseWhatsappFormParams;
  onSubmit: (lead: Lead) => void;
}

export function WhatsappFormRound({ whatsappParams, onSubmit }: IWhatsappFormProps) {
  const goToWhatsapp = useWhatsappForm(whatsappParams);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);

    if (onSubmit) {
      const lead = await goToWhatsapp();
      onSubmit(lead);
    }

    setButtonDisabled(false);
  }, [goToWhatsapp, onSubmit]);

  return (<form className={styles.form_round}  onSubmit={handleSubmit}>
    <button 
      type="submit"
      className={styles.whatsapp_round_button} 
      disabled={buttonDisabled} 
    />
  </form>);
}